import React from "react";
import "./DeleteCompetitorModal.scss";
import Modal from "../../../../../../../components/UIComponents/CustomModal/Modal";

const DeleteReport = ({ open, onClose, deleteCompetitorAccount, account }) => {
    const handleDeleteCompetitor = (account) => {
        const params = { research_query_id: account.research_query_id, id: account.subtopic_id };
        deleteCompetitorAccount(params);
        onClose();
    };

    return (
        <Modal className={`delete-report`} show={open} onClose={onClose}>
            <Modal.Header>
                <p className="header-text">Delete Competitor</p>
            </Modal.Header>
            <Modal.Content className="delete-report-content">
                <p>
                    Are you sure you want to delete <span className="report-to-be-deleted">{account && account?.name}</span> from competitors list? You will not
                    be able to recover them.
                </p>
            </Modal.Content>
            <Modal.Actions>
                <Modal.ActionButton normal onClick={onClose}>
                    Cancel
                </Modal.ActionButton>
                <Modal.ActionButton filled onClick={() => handleDeleteCompetitor(account)}>
                    Delete
                </Modal.ActionButton>
            </Modal.Actions>
        </Modal>
    );
};

export default DeleteReport;
